// Material Kit 2 React pages
import NewsAndEvents from "pages/LandingPages/NewsAndEvents";

export default function NewsAndEventsPage() {
  return <NewsAndEvents />;
}
